import i18n from "i18next";
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import {initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(HttpApi)
    .init({
        supportedLngs: ['en-CA', 'fr-CA', 'en-US','es-US'],
        debug: false,
        order: ['htmlTag', 'cookie', 'localStorage', 'path', 'subdomain'],
        backend: {
            loadPath: '/locales/{{lng}}/translation.json'
        },
        react: { useSuspense: false },
    });

export default i18n;